import { FunctionComponent } from 'react';
import CourseLanding from '../../components/courseLanding';
import SectionTitle from '../../../course/components/sectionTitle';
import Quiz from '../../components/quiz';
import Conversation from './conversation';
import Animation008 from './animation008';
import Animation027 from './animation027';
import Animation047 from './animation047';
import Animation048 from './animation048';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Animation008,
  Animation027,
  Animation047,
  Animation048,
  Component002,
  Component003,
  Component004,
};

export default Components;
